"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const map_data_service_1 = require("../commons/map-data.service");
const _4d_mapper_1 = require("4d-mapper");
const router_1 = require("@angular/router");
const rxjs_1 = require("rxjs");
const map_event_service_1 = require("../commons/map-event.service");
const map_event_objects_1 = require("../commons/map-event.objects");
const file_data_service_1 = require("../commons/file-data.service");
const veflux_1 = require("vasat/dist/src/veflux");
const tree_events_1 = require("../commons/files/tree-events");
const _ = require("lodash");
class MainComponent {
    constructor(fileManager, route, router, mapData, mapEvent, builder, elem) {
        this.fileManager = fileManager;
        this.route = route;
        this.router = router;
        this.mapData = mapData;
        this.mapEvent = mapEvent;
        this.builder = builder;
        this.elem = elem;
        this.projects = [];
        this.scenes = [];
        this.sceneLayers = [];
        this.scenePhotos = [];
        this.annotations = [];
        this.contextCursor = null;
        this.checked = {};
        this.checkedAnnot = {};
        // jobs
        this.jobTypes = new veflux_1.ArrayStore(tree_events_1.TreeEvent);
        this.selectedJob = new veflux_1.Store(tree_events_1.TreeEvent);
        this.sceneFolderStore = new veflux_1.ArrayStore(tree_events_1.TreeEvent);
        this.senceFolderSelected = new veflux_1.Store(tree_events_1.TreeEvent);
        this._subs = [];
    }
    ngOnInit() {
        // We're assuming somone is calling the code to init and set active team by this stage 
        // so how good is RXjs, this means that if either the team changes or the router params changes fire this method
        // preserving the last state of the thing that didnt change
        this._subs.push(rxjs_1.combineLatest(this.fileManager.team.events, this.route.params).subscribe(([s, params]) => {
            var projId = parseInt(params.projId);
            var sceneId = parseInt(params.sceneId);
            if (s.event == 'ADD' && (!this.mapData.scene.value || this.mapData.scene.value.id != sceneId)) {
                // listen to param changes
                // load the project and scene in one swoop
                this.mapData.loadProject(projId, sceneId).subscribe(_ => console.log('km'), e => console.error(e));
                // set the active tab from the url
                this.tab = params.tabId;
            }
            else if (s.event == 'REMOVE') {
                //this.mapData.clear()
            }
        }));
        // make me the click listener for the map
        this.mapEvent.setClickListener(this);
        //if the team changes remove them from the project and back to the project list
        this._subs.push(this.fileManager.team.events.subscribe(s => {
            if (s.event == 'REMOVE') {
                this.router.navigate(['../../..'], { relativeTo: this.route });
            }
        }));
        //if the project is toggled
        this._subs.push(this.mapData.project.state.subscribe(p => this.project));
        // when the scene changes
        this._subs.push(this.mapData.loadingScene.state.subscribe(s => this.loading = s));
        // when the scene changes
        this._subs.push(this.mapData.scene.state.subscribe(s => {
            this.scene = s;
            if (!s) {
                this.sceneLayers.splice(0, this.sceneLayers.length);
                this.scenePhotos.splice(0, this.scenePhotos.length);
            }
        }));
        // bind project list
        this._subs.push(this.fileManager.projects.state.subscribe(s => this.projects = s));
        // Sync the various arrays with local component versions
        this._subs.push(this.mapData.scenes.state.subscribe(s => this.scenes = s));
        this._subs.push(this.mapData.annotations.state.subscribe(s => this.annotations = s));
        this._subs.push(this.mapData.sceneLayers.state.subscribe(s => this.sceneLayers = s));
        this._subs.push(this.mapData.scenePhotos.state.subscribe(s => this.scenePhotos = s));
        // listen for drawn items so you can update the checkboxes
        this._subs.push(this.mapData.annotations.events.subscribe(s => {
            if (s.event == 'UPDATE' || s.event == 'ADD') {
                var visible = s.item['showPermanent'];
                if (visible)
                    this.mapData.displayedAnnotations.set(s.item);
                else
                    this.mapData.displayedAnnotations.remove(s.item);
                this.mapData.displayedPhotos.values = this.mapData.scenePhotos.values;
            }
        }));
        // listen for drawn items so you can update the checkboxes
        this._subs.push(this.mapData.sceneLayers.events.subscribe((s) => {
            if (s.event == 'UPDATE' || s.event == 'ADD') {
                var visible = (this.mapData.loadingScene.value || this.mapData.scene.value).isShowing(s.item);
                if (visible)
                    this.mapData.displayedLayers.set(s.item);
                else
                    this.mapData.displayedLayers.remove(s.item);
            }
        }));
        // listen for drawn items so you can update the checkboxes
        this._subs.push(this.mapData.displayedAnnotations.events.subscribe(s => {
            if (s.event == 'ADD')
                this.checkedAnnot[s.item.id + ''] = true;
            else if (s.event == 'REMOVE')
                this.checkedAnnot[s.item.id + ''] = false;
        }));
        // listen for drawn items so you can update the checkboxes
        this._subs.push(this.mapData.displayedLayers.events.subscribe(s => {
            if (s.event == 'ADD')
                this.checked[s.item.id + ''] = true;
            else if (s.event == 'REMOVE')
                this.checked[s.item.id + ''] = false;
        }));
        // lisgten out for cursor
        this._subs.push(this.mapEvent.cursor.events.subscribe(s => {
            if (s.event == 'UPDATE' && s.item.meta && s.item.meta.rightClick) {
                console.log(s.item);
                this.contextCursor = s.item;
            }
            else {
                this.contextCursor = null;
            }
        }));
        // listen for camera moves (to hide rightclick menu)
        this._subs.push(this.mapEvent.camera.events.subscribe(s => {
            if (s.event == 'start_move')
                this.cameraMoving = true;
            else if (s.event == 'moved')
                this.cameraMoving = false;
        }));
        // processing tab (Jobs)
        this._subs.push(this.mapData.scene.events.subscribe(ev => {
            if (ev.event == 'ADD')
                this.fetchJobs();
            else if (ev.event == 'REMOVE')
                this.jobTypes.values = [];
        }));
        this._subs.push(this.selectedJob.events.subscribe(ev => {
            if (ev.event == 'ADD' && ev.item.ref instanceof _4d_mapper_1.Job) {
                console.log('hello job', ev.item.ref);
            }
        }));
        // File view
        this._subs.push(this.mapData.sceneFolder.events.subscribe(ev => {
            if (ev.event == 'ADD') {
                this.sceneFolder = ev.item;
                this.sceneFolderStore.values = [this.builder.fromFolderWithFiles(this.sceneFolder, true)];
            }
            else if (ev.event == 'REMOVE')
                this.sceneFolder = null;
        }));
        this._subs.push(this.senceFolderSelected.events.subscribe(ev => {
            if (ev.item.ref instanceof _4d_mapper_1.Dataset && ev.item.ref['canPlot'] && ev.event == 'ADD')
                this.fileManager.fourD.V.searchByObject(_4d_mapper_1.Transform).equals('id', ev.item.ref['canPlot']).useCache(true).queryObservable().subscribe(s => {
                    if (s.items.length == 1)
                        this.mapData.displayedLayers.set(s.items[0]);
                    this.mapEvent.flyCameraTo(s.items[0]);
                });
            else if (ev.item.ref instanceof _4d_mapper_1.Dataset && ev.event == 'REMOVE') {
                this.mapData.displayedLayers.values = this.mapData.displayedLayers.values.filter(a => a.id != ev.item.ref['canPlot']);
            }
        }));
    }
    ngOnDestroy() {
        this._subs.forEach(s => s.unsubscribe());
        this.mapData.project.value = null;
    }
    fetchJobs() {
        this.jobTypes.values = [];
        _(this.mapData.fourD.jobTypes.filter(j => j.category && j.category != ''))
            .groupBy(i => i.category)
            .each((v, k) => this.jobTypes.set(this.builder.fromStaticInfo(k, v.map(jt => this.builder.fromJobType(jt, this.mapData), true))));
    }
    toggleLayer(t, e) {
        this.mapData.scene.value.setShowing(t, e.target.checked);
        this.mapData.scene.value.saveObservable().subscribe();
        this.mapData.sceneLayers.emmit(t, 'UPDATE');
    }
    toggleAnnot(t, e) {
        t['showPermanent'] = e.target.checked;
        t.saveObservable();
    }
    onMapClicked(position, feature, isRight) {
        console.log('MainComponent', position, feature);
        if (feature instanceof _4d_mapper_1.Transform) {
            if (feature.ds_type_uid == 'photo')
                this.router.navigate(['photo', feature.id], { relativeTo: this.route });
            else
                this.router.navigate(['layer', feature.id], { relativeTo: this.route });
        }
        else if (feature instanceof _4d_mapper_1.Annotation) {
            this.router.navigate(['annot', feature.id], { relativeTo: this.route });
        }
        else {
            // must be a ncier wauy to do this
            var routePath = [];
            this.route.snapshot.pathFromRoot.forEach(p => p.url.forEach(a => routePath.push(a.path)));
            this.router.navigate(routePath);
        }
        // upadte the cursor on the mapEvent, this will fire events (rightClick hides)
        this.mapEvent.cursor.value = isRight ? new map_event_objects_1.Cursor(position, 'YELLOW', { rightClick: true, feature: feature }) : new map_event_objects_1.Cursor(position, 'PURPLE');
        return true;
    }
    jumpTo(path) {
        this.router.navigate(path, { relativeTo: this.route });
    }
}
exports.MainComponent = MainComponent;
